import { render, staticRenderFns } from "./DoctorBooking.vue?vue&type=template&id=6a7601d6&scoped=true&lang=pug"
import script from "./DoctorBooking.vue?vue&type=script&lang=js"
export * from "./DoctorBooking.vue?vue&type=script&lang=js"
import style0 from "./DoctorBooking.vue?vue&type=style&index=0&id=6a7601d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7601d6",
  null
  
)

export default component.exports